import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCJ8KOzUFnI9w09OOJc1HYTE0qiMms4ARM",
  authDomain: "footy-tabs.firebaseapp.com",
  databaseURL: "https://footy-tabs.firebaseio.com",
  projectId: "footy-tabs",
  storageBucket: "footy-tabs.firebasestorage.app",
  messagingSenderId: "843151716251",
  appId: "1:843151716251:web:2546c91390d2e735607b3e",
  measurementId: "G-6E0G6RLCB9"
};

// Initialize Firebase only if config is provided
let app = null;
let analytics = null;

if (firebaseConfig.projectId) {
  try {
    app = initializeApp(firebaseConfig);
    if (typeof window !== 'undefined') {
      analytics = getAnalytics(app);
    }
  } catch (error) {
    console.warn('Firebase initialization failed:', error.message);
  }
}

export { app, analytics };
